export const GET_IFRAMES_START = 'GET_IFRAMES_START';
export const GET_IFRAMES_SUCCESS = 'GET_IFRAMES_SUCCESS';
export const GET_IFRAMES_FAIL = 'GET_IFRAMES_FAIL';

export const GET_IFRAME_START = 'GET_IFRAME_START';
export const GET_IFRAME_SUCCESS = 'GET_IFRAME_SUCCESS';
export const GET_IFRAME_FAIL = 'GET_IFRAME_FAIL';

export const UPDATE_IFRAME_START = 'UPDATE_IFRAME_START';
export const UPDATE_IFRAME_SUCCESS = 'UPDATE_IFRAME_SUCCESS';
export const UPDATE_IFRAME_FAIL = 'UPDATE_IFRAME_FAIL';

export const DELETE_IFRAME_START = 'DELETE_IFRAME_START';
export const DELETE_IFRAME_SUCCESS = 'DELETE_IFRAME_SUCCESS';
export const DELETE_IFRAME_FAIL = 'DELETE_IFRAME_FAIL';

export const GET_AVAILABLE_EVENTS_START = 'GET_AVAILABLE_EVENTS_START';
export const GET_AVAILABLE_EVENTS_SUCCESS = 'GET_AVAILABLE_EVENTS_SUCCESS';
export const GET_AVAILABLE_EVENTS_FAIL = 'GET_AVAILABLE_EVENTS_FAIL';

export const GET_THEME_START = 'GET_THEME_START';
export const GET_THEME_SUCCESS = 'GET_THEME_SUCCESS';
export const GET_THEME_FAIL = 'GET_THEME_FAIL';

export const UPDATE_THEME_START = 'UPDATE_THEME_START';
export const UPDATE_THEME_SUCCESS = 'UPDATE_THEME_SUCCESS';
export const UPDATE_THEME_FAIL = 'UPDATE_THEME_FAIL';
